<!--
* UI Name: Communication Right Layout
* Modify Date: 2022/12/06
-->
<template>
  <div class="cus-bg-dialog" style="top: 0; right: 0; left: auto; padding: 10px 20px 20px 20px">
    <v-card-title class="headline white--text px-6 mr-5" primary-title>
      <v-btn
        disabled
        class="mb-1 mr-1 proc-button-style proc-comm drag-drawflow"
        x-small
        height="30"
        width="30"
        color="proc darken-1"
      >
        <icon-svg :size="procIconSize" iconName="proc-comm" />
      </v-btn>
      <font class="text-xl font-bold leading-snug textcolor5--text">
        Connector
      </font>
      <v-spacer></v-spacer>
      <v-btn
        class="btn btn-save rounded-xl mr-2"
        :disabled="!$auth.manage"
        v-if="!isHistory"
        @click="saveData"
        >{{ $t('btn.common.save') }}</v-btn
      >
      <v-btn
        class="btn btn-delete rounded-xl mr-2"
        :disabled="!$auth.manage || !formData.id"
        v-if="!isHistory"
        @click="deleteComm"
        >{{ $t('btn.common.delete') }}</v-btn
      >
      <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
        $t('btn.common.close')
      }}</v-btn>
    </v-card-title>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="4" class="pl-3 pr-2 py-0">
          <v-label>Type</v-label>
          <v-select
            v-model="typeCom"
            :items="types"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            @change="changeComType()"
          ></v-select>
        </v-col>
        <v-col cols="12" md="8" class="pr-3 pl-2 py-0">
          <div class="d-flex justify-space-between align-center">
            <v-label class="pt-2">Name</v-label>
            <div class="right-text">
              <v-btn
                style="visibility: hidden; height: 22px"
                :disabled="isHistory"
                class="px-0"
                @click="copyData"
              >
                <icon-svg style="visibility: visible" width="60" height="22" iconName="comp-copy" />
              </v-btn>
              <v-btn
                style="visibility: hidden; height: 22px"
                :disabled="isHistory"
                class="px-0"
                @click="clearData"
              >
                <icon-svg
                  style="visibility: visible"
                  width="60"
                  height="22"
                  iconName="comp-clear"
                />
              </v-btn>
            </div>
          </div>
          <v-combobox
            v-model="comId"
            :items="communicationList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="id"
            item-text="name"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-combobox>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col v-if="typeCom === 'FTP'" cols="12" md="12" class="px-4 pt-0">
          <FTPS
            ref="FTP"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></FTPS>
        </v-col>
        <v-col v-if="typeCom === 'FTPS'" cols="12" md="12" class="px-4 pt-0">
          <FTPS
            ref="FTPS"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></FTPS>
        </v-col>
        <v-col v-else-if="typeCom === 'SFTP'" cols="12" md="12" class="px-4 pt-0">
          <SFTP
            ref="SFTP"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></SFTP>
        </v-col>
        <v-col v-else-if="typeCom === 'IMAP'" cols="12" md="12" class="px-4 pt-0">
          <IMAP
            ref="IMAP"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></IMAP>
        </v-col>
        <v-col v-else-if="typeCom === 'POP3'" cols="12" md="12" class="px-4 pt-0">
          <POP3
            ref="POP3"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></POP3>
        </v-col>
        <v-col v-else-if="typeCom === 'SMTP'" cols="12" md="12" class="px-4 pt-0">
          <SMTP
            ref="SMTP"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></SMTP>
        </v-col>
        <v-col v-else-if="typeCom === 'API'" cols="12" md="12" class="px-4 pt-0">
          <REST_API
            ref="API"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></REST_API>
        </v-col>
        <v-col v-else-if="typeCom === 'IBM_MQ'" cols="12" md="12" class="px-4 pt-0">
          <MQ
            ref="IBM_MQ"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></MQ>
        </v-col>
        <v-col v-else-if="typeCom === 'ACTIVE_MQ'" cols="12" md="12" class="px-4 pt-0">
          <MQ
            ref="ACTIVE_MQ"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></MQ>
        </v-col>
        <v-col v-else-if="typeCom === 'SOAP'" cols="12" md="12" class="px-4 pt-0">
          <SOAP_API
            ref="SOAP"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></SOAP_API>
        </v-col>
        <v-col v-else-if="typeCom === 'HTTP'" cols="12" md="12" class="px-4 pt-0">
          <HTTP
            ref="HTTP"
            :item="formData"
            :nodeId="nodeId"
            :isHistory="isHistory"
            @check-data-change="checkDataChange"
          ></HTTP>
        </v-col>
      </v-row>
    </v-form>

    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Connector', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Connector', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="deleteComm"
      title="Delete Comm"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['Connector'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
    <dialogWindow
      ref="AlertCommSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertCommSetup.dialog = false"
    >
    </dialogWindow>
  </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
// import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
// const moment = require("moment");
import FTPS from './communication/FTPS';
import SFTP from './communication/SFTP';
import IMAP from './communication/IMAP';
import POP3 from './communication/POP3';
import SMTP from './communication/SMTP';
import REST_API from './communication/REST-API';
import MQ from './communication/MQ';
import SOAP_API from './communication/SOAP-API';
import HTTP from './communication/HTTP';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    // DialogDrag,
    discardChange,
    IconSvg,
    FTPS,
    SFTP,
    IMAP,
    POP3,
    SMTP,
    REST_API,
    MQ,
    SOAP_API,
    HTTP,
  },

  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      checkDialogInfo: '',
      checkDialogColor: 'warning',
      types: [
        { text: 'FTP', value: 'FTP' },
        { text: 'FTP(S)', value: 'FTPS' },
        { text: 'SFTP', value: 'SFTP' },
        { text: 'IMAP', value: 'IMAP' },
        { text: 'POP3', value: 'POP3' },
        { text: 'SMTP', value: 'SMTP' },
        { text: 'REST API', value: 'API' },
        { text: 'IBM MQ', value: 'IBM_MQ' },
        { text: 'ACTIVE MQ', value: 'ACTIVE_MQ' },
        { text: 'SOAP', value: 'SOAP' },
        { text: 'HTTP', value: 'HTTP' },
      ],
      formData: {
        id: '',
        type: '',
        name: '',
      },
      loadFormData: {},
      typeCom: 'FTP',
      nodeId: '',
      comTp: 'COM',
      s_item: {
        vtype: '',
        vinout: '',
      },
    };
  },
  watch: {
    nodeId() {
      if (this.$refs.dialogSearch) this.$refs.dialogSearch.resetComb();
    },
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },

  methods: {
    copyData() {
      this.formData.id = '';
      this.formData.name = '';
      this.comId = '';
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    clearData() {
      this.changeComm('');
      this.comId = '';
    },
    changeComponentData() {
      if (this.comId && this.comId.value) {
        this.changeComm(this.comId.value);
      } else {
        if (this.formData.id) {
          this.changeComm('');
        }
        this.formData.name = this.comId;
      }
      this.validateCommName();
    },
    validateCommName() {
      this.communicationList.map((e) => {
        if (e.name === this.formData.name && e.id !== this.formData.id) {
          this.formData.name = '';
          this.comId = '';
          this.checkDialogInfo = `Communication name : ${e.text} have been created !`;
          this.checkDialogColor = 'warning';
          this.$refs.AlertCommSetup.dialog = true;
          return;
        }
      });
    },
    actionDel() {
      let self = this;
      this.$store.dispatch('deleteComm', { id: this.formData.id, s_item: this.s_item }).then(() => {
        console.log('--------- Delete Communication -----');
        this.$store.dispatch('getCommunicationSelectBoxList').then(() => {
          this.$refs.form.resetValidation();
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'COM') {
              if (comp.formData.id === self.formData.id) {
                comp.resetForm();
              }
            }
          });
          this.changeComm('');
        });
      });
    },
    deleteComm() {
      if (cfg.isDlb) {
        this.$refs.deleteComm.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'COM',
            value: this.formData.id,
          })
          .then((res) => {
            if (res.length > 0) {
              EventBus.$emit('openDelHistoryWorkflowDialog', res, this.formData, this.nodeId);
            } else {
              this.$refs.deleteComm.dialog = true;
            }
          });
      }
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      if (this.options.item.data.comId) {
        let index = this.communicationList.findIndex((e) => e.id == this.options.item.data.comId);
        if (index > -1 && (this.manage || this.isHistory)) {
          this.formData = Object.assign({}, this.getInitData(), this.communicationList[index]);
          this.comId = Object.assign({}, this.getInitData(), this.communicationList[index]);
        }
        this.typeCom = this.formData.type;
      } else {
        this.changeComm('');
      }
    },
    async changeComm(id) {
      if (id) {
        let count = 0;
        let usedList = [];
        $('.proc-component.v-card.v-sheet').each(function() {
          let comp = $(this)[0].__vue__.$parent;
          if (comp.comTp == 'COM' && comp.formData.id === id) {
            count += 1;
            usedList.push(comp.nodeId);
          }
        });
        this.formData = Object.assign(
          {},
          this.getInitData(),
          this.communicationList.filter((e) => e.id == id)[0],
        );
        this.typeCom = this.formData.type;
        if (count > 0 && !usedList.includes(this.nodeId)) {
          this.$nextTick(() => {
            EventBus.$emit('change-component-data', '', this.nodeId);
          });
        } else {
          EventBus.$emit('change-component-data', id, this.nodeId);
        }
      } else {
        this.formData = Object.assign({}, this.getInitData());
        this.formData.type = this.typeCom;
        // this.comId = '';
        EventBus.$emit('change-component-data', '', this.nodeId);
        if (this.$refs[this.typeCom]) this.$refs[this.typeCom].resetFormData();
      }
    },
    changeComType() {
      this.formData = Object.assign({}, this.getInitData());
      this.formData.type = this.typeCom;
      this.comId = '';
      if (this.$refs[this.typeCom]) this.$refs[this.typeCom].resetFormData();
    },
    async saveData() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      let validResult = this.$refs.form.validate();
      if (validResult) {
        let result = await this.$refs[this.typeCom].save(this.formData);
        if (result !== -1) {
          this.saveSuccess();
        }
      }
    },
    saveSuccess() {
      if (this.formData.id) {
        this.$refs.ModifiedSuccess.dialog = true;
      } else {
        this.$refs.RegisteredSuccess.dialog = true;
      }
    },
    getInitData() {
      return {
        name: '',
        partner: '',
        security: '',
        userid: '',
        password: '',
        path: '',
        interval: '30',
        type: '',
        showpassword: true,
      };
    },
    closeComDialog() {
      if (this.$refs[this.typeCom]) this.$refs[this.typeCom].checkDataChange();
    },
    checkDataChange(data) {
      if (Object.keys(data).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  computed: {
    communicationList() {
      return this.$store.getters.communicationSelectBoxList;
    },
  },
};
</script>
